import { createContext } from 'react'

export const userFlow = createContext({
    showMenu: false,
    setShowMenu: () => { },
    auth_google_facebook: false,
    setAuth: () => { }
})